import React, { useState } from "react";

export default function BuyNow({ data,patching ,deleting}) {
  const [search, setSearch] = useState("");
  const [filteredList, setFilteredList] = useState([]);
//   const [buy,setBuy]=useState(filteredList)
  function handleClick(buyCar){
    console.log("clicked id " + buyCar.id)
    let newQuantity= buyCar.quantity --
    console.log(newQuantity)
    if (buyCar.quantity >0){
        patching(buyCar.id,{quantity:parseInt(newQuantity)})
    }
    else{
        alert("Car out of Stock")
        deleting(buyCar.id)
    }
  }

  function handleSubmit(e) {
    e.preventDefault();
    const filteredData = data.filter((item) => item.brand === search);
    const filterList = filteredData.map((datum) => (
      <div id="cars-list" key={datum.id}>
        <div className="card">
          <h1 className="brand">
            Brand: {datum.brand} ({datum.year} Model)
          </h1>
          <img className="image" src={datum.image} alt="car" />
          <p className="mileage">Mileage: {datum.mileage}</p>
          <p className="mileage">Price: Ksh {datum.price}</p>
          <p className="quantity">Quantity: {datum.quantity}</p>
          <button className="btn" onClick={()=>handleClick(datum)}>Buy Car</button>
        </div>
      </div>
    ));

    setFilteredList(filterList);
  }

  function handleChange(e) {
    setSearch(e.target.value);
  }

  return (
    <div>
      <form className="search-form" onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Search car"
          className="search-car"
          value={search}
          onChange={handleChange}
        />
        <input type="submit" value="Search" className="search" />
      </form>

      {filteredList.length > 0 ? (
        <div>{filteredList}</div>
      ) : (
        <div className="no-car">
          <h3 className="no-cars">No Car Found. Please Try Again.</h3>
        </div>
      )}
    </div>
  );
}
